import { atom } from "recoil";
import { IAcquisitionConfig } from "../Type";

export const addStateAcquisitionConfig = atom({
  key: "addStateAcquisitionConfig",
  default: false,
});
export const editStateAcquisitionConfig = atom({
  key: "editStateAcquisitionConfig",
  default: false,
});
export const rowEditAcquisitionConfig = atom<IAcquisitionConfig | undefined>({
  key: "rowEditAcquisitionConfig",
  default: undefined,
});

export const selectedRowsStateAcquisitionConfig = atom<IAcquisitionConfig[]>({
  key: "selectedRowsStateAcquisitionConfig",
  default: [],
});

export const acquisitionConfigFilterText = atom({
  key: "acquisitionConfigFilterText",
  default: "",
});

export const acquisitionConfigFetching = atom({
  key: "acquisitionConfigFetching",
  default: true,
});
export const acquisitionConfigReFetching = atom({
  key: "acquisitionConfigReFetching",
  default: false,
});
